/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Slider from 'react-slick'
import user_img from '../../assets/img/review_user.png'
import reting_star from '../../assets/img/svg/review_star.svg'
import { Avatar } from 'antd'
import { appendImageURL, generateNumberPattern, getWindowDivSize } from '../../helper/function'
import { Rating } from 'react-simple-star-rating'
import { defaultUserImg } from '../../helper/imagepath'

const CommonReviewSlider = ({ id, fetchReviews, reviewDataSelector, profileImageSelector, nameSelector, totalRecords }) => {
  const dispatch = useDispatch()
  const reviewsData = useSelector(reviewDataSelector) || []
  const sliderRef = useRef()
  const [pageSize, setPageSize] = useState(getWindowDivSize())
  const [currentPage, setCurrentPage] = useState(1)
  const [reviewSlides, setReviewSlides] = useState([])
  const [reviewState, setReviewState] = useState([])
  const [hasMoreReviews, setHasMoreReviews] = useState(true)
  const [visitSlide, setVisitSlide] = useState(0)

  // Check if there are more reviews to fetch
  useEffect(() => {
    setHasMoreReviews(reviewState.length !== totalRecords)
  }, [reviewState, totalRecords])

  // Append reviews data
  useEffect(() => {
    if (reviewsData.length) {
      setReviewState((prev) => [...prev, ...reviewsData])
    }
  }, [reviewsData])

  // Generate slides based on the number of reviews
  useEffect(() => {
    if (totalRecords) {
      setReviewSlides(generateNumberPattern(totalRecords, pageSize))
    }
  }, [totalRecords, pageSize])

  // Fetch reviews data
  useEffect(() => {
    if (!hasMoreReviews) return

    const data = {
      id,
      params: { page: currentPage, limit: pageSize }
    }

    dispatch(fetchReviews(data)).catch((error) => {
      console.error('Error fetching reviews:', error)
    })
  }, [currentPage, pageSize, hasMoreReviews, id, fetchReviews, dispatch])

  // Resize event handler
  useEffect(() => {
    const handleResize = () => setPageSize(getWindowDivSize())
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleNextClick = () => setCurrentPage((prev) => prev + 1)

  const SampleNextArrow = (props) => {
    const { className, onClick, currentSlide } = props
    return (
      <div
        className={className}
        onClick={() => {
          if (!className?.includes('slick-disabled')) {
            onClick()
            setVisitSlide(currentSlide)
            if (visitSlide <= currentSlide) {
              handleNextClick()
            }
          }
        }}
      />
    )
  }

  const SamplePrevArrow = (props) => {
    const { className, onClick } = props
    return <div className={className} onClick={() => !className?.includes('slick-disabled') && onClick()} />
  }

  useEffect(() => {
    setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0)
      }
    }, 500)
  }, [])

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    lazyLoad: true,
    draggable: false,
    swipeToSlide: false,
    initialSlide: 0,
    touchMove:false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: false } },
      { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: false } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false } }
    ],
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  }

  return (
    <div className="mb-5">
      <div className="common_heading_div">
        <h4>Reviews</h4>
      </div>
      <div className="review_slider_main_div">
        {totalRecords ? (
          <Slider ref={sliderRef} {...settings} onSwipe={(val)=>console.log("value",val)}>
            {reviewSlides?.map((_, index) => (
              <div className="review_sec" key={index}>
                <div className="review_box">
                  <div className="review_sec_dataset">
                    <div className="review_user_img_sec">
                      <div className="cleanings_img_div">
                        <div className="img_div">
                          <img
                            className="img-fluid"
                            // src={
                            //   reviewsData?.propertySchedule?.properties_id?.client_id?.profile_image
                            //     ? appendImageURL(reviewsData?.propertySchedule?.properties_id?.client_id?.profile_image)
                            //     : defaultUserImg
                            // }
                            src={profileImageSelector(reviewState[index]) || defaultUserImg}
                            alt="Image"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="review_sec_data">
                      <h4 className="review_user_name">{nameSelector(reviewState[index])}</h4>
                      <div className="review_rating">
                        {/* {Array(Math.max(0, Math.floor(Number(reviewState[index]?.star || 0))))
                          .fill(0)
                          .map((_, i) => (
                            <img className="reting_star" key={i} src={reting_star} alt="rating_star" />
                          ))} */}
                        <Rating
                          className="star_img"
                          initialValue={reviewState[index]?.star} // Set initial value
                          size={15}
                          fillColor="#FD9B2E"
                          emptyColor="gray"
                          allowFraction
                          readonly
                        />
                      </div>
                      <p className="review_text">{reviewState[index]?.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <h4 className="not_found text-center">No Data Found</h4>
        )}
      </div>
    </div>
  )
}

export default CommonReviewSlider
